// KIKI logo image. Since the source logo has black text + yellow shield,
// on dark backgrounds we render it inside a cream card so it stays legible.
export function KikiLogo({ onDark = false, className = "h-8 md:h-9 w-auto" }) {
  const img = (
    <img
      src="/kiki-logo.png"
      alt="KIKI Centre for Technology"
      className={`${className} select-none`}
      draggable={false}
    />
  );
  if (!onDark) return img;
  return (
    <span className="inline-flex items-center bg-[#F5F5F0] px-3 py-1.5 rounded-lg">
      {img}
    </span>
  );
}
